import useConfigurePosthog from './useConfigurePosthog'
import usePageViewTracker from './usePageViewTracker'
import useScrollRestoration from './useScrollRestoration'

export default function useSetupApp () {
  useConfigurePosthog()
  usePageViewTracker()
  useScrollRestoration()
}
